import React from 'react';

import {
    FormikDateField,
    FormikFileUploadField,
    FormikNumberField,
    FormikSelectField,
    FormikTextField,
} from '~/@components/FormikFields';
import { Grid } from '~/@components/Grid';
import { LocalizableText } from '~/@components/LocalizableText';
import { DeliveryLineEditStatusSelect } from '~/@views/UserView/ProjectPage/common/DeliveryLineEditForm/DeliveryLineEditStatusSelect';
import { commonPrecisions, Engine, Fuel } from '~/config/enum';

import { DeliveryLineEditOrderSelect } from './DeliveryLineEditOrderSelect';
import { useDeliveryLineFormikContext } from './DeliveryLineFormikCommon';
import { DeliveryLineVehicleTypeSelect } from './DeliveryLineVehicleTypeSelect';

const engineItems = [Engine.Euro7, Engine.Euro6, Engine.Euro5, Engine.Euro4];
const fuelItems = [Fuel.Diesel, Fuel.Electric, Fuel.HVO100];

export const DeliveryLineEditFields = () => {
    const formik = useDeliveryLineFormikContext();

    const readonly = formik.values.isVerified;

    return (
        <>
            <Grid container spacing={3}>
                <Grid item xs={6}>
                    <DeliveryLineEditOrderSelect disabled={readonly} />
                </Grid>
                <Grid item xs={6}>
                    <DeliveryLineEditStatusSelect disabled={readonly} />
                </Grid>
            </Grid>
            <Grid container spacing={3}>
                <Grid item xs={6}>
                    <FormikNumberField
                        label={<LocalizableText code={'DeliveryLineCard.weight'} />}
                        precision={commonPrecisions.amount}
                        name="weight"
                        min={0}
                        formik={formik}
                        disabled={readonly}
                    />
                </Grid>

                <Grid item xs={6}>
                    <FormikDateField
                        label={<LocalizableText code={'DeliveryLineCard.date'} />}
                        name="date"
                        formik={formik}
                        disabled={readonly}
                    />
                </Grid>

                <Grid item xs={4}>
                    <FormikTextField
                        label={<LocalizableText code={'DeliveryLineCard.truckRegistrationNumber'} />}
                        name="truckRegistrationNumber"
                        formik={formik}
                        disabled={readonly}
                    />
                </Grid>

                <Grid item xs={4}>
                    <FormikNumberField
                        label={<LocalizableText code={'DeliveryLineCard.truckCapacity'} />}
                        name="truckCapacity"
                        precision={commonPrecisions.amount}
                        min={0}
                        formik={formik}
                        disabled={readonly}
                    />
                </Grid>

                <Grid item xs={4}>
                    <DeliveryLineVehicleTypeSelect disabled={readonly} />
                </Grid>

                <Grid item xs={4}>
                    <FormikSelectField
                        label={<LocalizableText code={'DeliveryLineCard.fuel'} />}
                        name={'fuel'}
                        formik={formik}
                        items={fuelItems}
                        renderValue={i => i}
                        keyGetter={i => i}
                        addEmptyOption={false}
                        valueCaption={i => i}
                        disabled={readonly}
                    />
                </Grid>

                <Grid item xs={4}>
                    <FormikSelectField
                        label={<LocalizableText code={'DeliveryLineCard.engine'} />}
                        name={'engine'}
                        formik={formik}
                        items={engineItems}
                        renderValue={i => i}
                        keyGetter={i => i}
                        addEmptyOption={false}
                        valueCaption={i => i}
                        disabled={readonly}
                    />
                </Grid>

                <Grid item xs={12}>
                    <FormikTextField
                        label={<LocalizableText code={'DeliveryLineCard.senderNotes'} />}
                        name="senderComment"
                        formik={formik}
                    />
                </Grid>
                <Grid item xs={12}>
                    <FormikTextField
                        label={<LocalizableText code={'DeliveryLineCard.driverComment'} />}
                        name="driverComment"
                        formik={formik}
                    />
                </Grid>

                <Grid item xs={12}>
                    <FormikFileUploadField
                        label={<LocalizableText code={'DeliveryLineCard.receipt'} />}
                        name="receipt"
                        formik={formik}
                        disabled={readonly}
                    />
                </Grid>
            </Grid>
        </>
    );
};
